import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  { id: "8e5e3e32-3843-428f-b4a1-4a7efae0b06f", options: { image: `${config.ASSETS_URL}/01/18/task/task-1-eq-1.svg` } },
  { id: "ccdf97b1-259d-49b9-9e18-4120a243d1b2", options: { image: `${config.ASSETS_URL}/01/18/task/task-1-eq-2.svg` } },
  { id: "fedf9a4d-4399-43d0-95ab-23d62ff31a16", options: { image: `${config.ASSETS_URL}/01/18/task/task-1-eq-3.svg` } },
  { id: "e36f4176-60e6-4f8b-bf7c-b0910f3a2d63", options: { image: `${config.ASSETS_URL}/01/18/task/task-1-eq-4.svg` } },
];

export const task: Task = {
  id: "0637cea7-7120-481c-85ed-21c6dfe2e23d",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
    imageHeight: 90,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["ccdf97b1-259d-49b9-9e18-4120a243d1b2"],
};
